import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large ProposalActions",
    title: _ctx.modalTitle,
    "confirm-button-text": _ctx.modalConfirmButtonText,
    "confirm-button-class": _ctx.isDelete ? 'small red' : undefined,
    "confirm-message": `Вы действительно хотите удалить заявку клиента ${_ctx.state.name}?`,
    "is-confirm": _ctx.isDelete,
    loading: _ctx.loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitManager
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        class: "w-full",
        placeholder: "Имя и Фамилия",
        "is-invalid": _ctx.state_form$.name.$error,
        "validation-errors": _ctx.state_form$.name.$errors,
        value: _ctx.state.name,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.name) = $event))
      }, null, 8, ["is-invalid", "validation-errors", "value"]),
      _createVNode(_component_the_input, {
        class: "w-full mt-3",
        placeholder: "Телефон",
        "is-invalid": _ctx.state_form$.phoneNumber.$error,
        "validation-errors": _ctx.state_form$.phoneNumber.$errors,
        value: _ctx.state.phoneNumber,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.phoneNumber) = $event))
      }, null, 8, ["is-invalid", "validation-errors", "value"])
    ]),
    _: 1
  }, 8, ["title", "confirm-button-text", "confirm-button-class", "confirm-message", "is-confirm", "loading", "onCancel", "onConfirm"]))
}